import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9005Component } from './kymw9005.component';
import { GetAssociatedUserManagementDetailService } from './api-service/get-associated-user-management-detail.service'; 
import { RegistAssociatedUserManagementService } from './api-service/regist-associated-user-management.service';
import { UpdateAssociatedUserManagementService } from './api-service/update-associated-user-management.service';

/**
 * ユーザ情報詳細画面 モジュール設定クラス
 *
 * @export KYMW9005Module
 * @class KYMW9005Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9005Component,
  ],
  providers: [
    GetAssociatedUserManagementDetailService,
    RegistAssociatedUserManagementService,
    UpdateAssociatedUserManagementService,    
  ],
})
export class KYMW9005Module {

}